<template>
  <div class="input-wrapper">
    <div class="relative" :class="!hasFloatLabel && 'flex flex-col-reverse gap-2'">
      <Label
        :for="name"
        :class="[
          'pointer-events-none bg-background px-2 text-sm',
          error && 'text-destructive',
          hasFloatLabel &&
            'absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform text-black/60 duration-150 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:bg-background/100 peer-focus:px-2 peer-focus:!text-black/100 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4',
        ]"
        >{{ label }}</Label
      >
      <PhoneNumberInput
        v-model="modelValue"
        placeholder="Phone number"
        :error="error"
        :disabled="disabled"
      />
    </div>
    <span class="input-error" v-if="error">{{ error }}</span>
  </div>
</template>

<script setup lang="ts">
import Label from '@ui/label/Label.vue';
import PhoneNumberInput from './PhoneNumberInput.vue';

interface PhoneNumberProps {
  label: string;
  placeholder: string;
  name: string;
  error?: string;
  disabled?: boolean;
  hasFloatLabel?: boolean;
}

withDefaults(defineProps<PhoneNumberProps>(), {
  type: 'text',
  error: undefined,
  hasFloatLabel: true,
});

const modelValue = defineModel<string>('modelValue', {
  required: true,
});
</script>
